import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GetWithdrawalDraftResponse} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetWithdrawalDraftResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalWithdrawalDraft = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalWithdrawalDraft = async () => {
    const res = await axiosClient.get<GetWithdrawalDraftResponse>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_QUERY_KEY,
      getNonNationalWithdrawalDraft,
      {
        onSuccess,
        onError,
        enabled: false,
      }
  );
};
